module.exports = __webpack_public_path__ + "static/img/red_02_179.01cb41b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/red_02_179.png
// module id = Wiqd
// module chunks = 0